/* Natura Bisse exclusive gifts: cart section, step picker, and cart reconciliation. */
(function () {
  if (window.__nbGifts) return;
  window.__nbGifts = true;

  var KEY_DISMISSED = 'nbGiftBagDismissed';
  var KEY_SEEN = 'nbGiftBagSeen';
  var busy = false;
  var timer = null;
  var cfg = null;
  var modal = null;
  var selection = {};
  var stepIndex = 0;

  function readCfg() {
    var el = document.querySelector('script[data-nb-gifts-config]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function ss(get, key, val) {
    try {
      if (get) return sessionStorage.getItem(key);
      if (val === null) sessionStorage.removeItem(key); else sessionStorage.setItem(key, val);
    } catch (e) {}
    return null;
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: cfg.currency, minimumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(0); }
  }

  function giftIds() {
    var ids = {};
    if (cfg.bag) ids[cfg.bag.id] = true;
    cfg.steps.forEach(function (s) { ids[s.id] = true; });
    return ids;
  }

  function isGift(item, ids) {
    return !!(item.properties && item.properties._nb_gift) || !!ids[item.variant_id];
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); });
  }

  function spend(cart, ids) {
    var vendor = cfg.vendor.toLowerCase();
    return cart.items.reduce(function (sum, item) {
      if (isGift(item, ids)) return sum;
      if ((item.vendor || '').toLowerCase() !== vendor) return sum;
      return sum + item.final_line_price;
    }, 0);
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function setItems() {
    var items = [];
    if (cfg.bag) items.push({ id: cfg.bag.id, quantity: 1, properties: { _nb_gift: '1' } });
    cfg.steps.forEach(function (s) { items.push({ id: s.id, quantity: 1, properties: { _nb_gift: '1' } }); });
    return items;
  }

  function setAvailable() {
    if (!cfg.bag || !cfg.bag.available || cfg.steps.length < 3) return false;
    return cfg.steps.every(function (s) { return s.available; });
  }

  /* Shopify only discounts the gifts when the whole set is present, so the set
     is always added and removed together. Returns true when the cart changed. */
  function reconcile(cart) {
    var ids = giftIds();
    var total = spend(cart, ids);
    var unlocked = total >= cfg.threshold;
    var gifts = cart.items.filter(function (i) { return isGift(i, ids); });
    var need = setItems().length;
    var present = {};
    gifts.forEach(function (g) { present[g.variant_id] = g.quantity; });
    var complete = Object.keys(present).length === need && Object.keys(present).every(function (k) { return present[k] === 1; });
    var updates = {};
    var changed = false;

    if (gifts.length && (!unlocked || !complete)) {
      gifts.forEach(function (g) { updates[g.key] = 0; changed = true; });
    }
    if (!unlocked) {
      ss(false, KEY_DISMISSED, null);
      ss(false, KEY_SEEN, null);
    } else if (complete) {
      ss(false, KEY_SEEN, '1');
    } else if (!gifts.length && ss(true, KEY_SEEN) === '1') {
      ss(false, KEY_DISMISSED, '1');
    }

    var chain = Promise.resolve(cart);
    if (changed) chain = chain.then(function () { return post('/cart/update.js', { updates: updates }); });

    var needAdd = cfg.autoAdd && unlocked && !gifts.length && setAvailable() && ss(true, KEY_DISMISSED) !== '1';
    if (needAdd) {
      chain = chain.then(function () { return post('/cart/add.js', { items: setItems() }); })
        .then(function () { ss(false, KEY_SEEN, '1'); });
      changed = true;
    }
    return chain.then(function () { return changed; });
  }

  function onCartPage() { return /\/cart\/?$/.test(location.pathname); }

  function run(opts) {
    if (busy) return Promise.resolve(false);
    busy = true;
    return getCart().then(function (cart) {
      return reconcile(cart).then(function (changed) {
        busy = false;
        if (changed && !(opts && opts.noReload)) {
          var last = parseInt(ss(true, 'nbLastReload') || '0', 10);
          if (onCartPage() && Date.now() - last > 5000) { ss(false, 'nbLastReload', String(Date.now())); location.reload(); return changed; }
        }
        return getCart().then(function (c2) { render(c2); return changed; });
      });
    }).catch(function () { busy = false; return false; });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () { run(); }, 450);
  }

  /* ---------- rendering ---------- */
  function slotHtml(step, idx, inCart, locked) {
    if (!step.available && !inCart) {
      return '<div class="nb-slot"><span>' + esc(step.label) + '</span><span class="nb-tag">Unavailable</span></div>';
    }
    if (inCart) {
      return '<div class="nb-slot">' + (step.image ? '<img src="' + step.image + '" alt="">' : '') +
        '<span>' + esc(step.title) + '</span><span class="nb-tag">Added</span>' +
        '<button type="button" class="nb-link" data-nb-remove="1">Remove gifts</button></div>';
    }
    return '<div class="nb-slot"><button type="button" class="nb-plus" data-nb-open="' + idx + '" aria-label="Choose ' + esc(step.label) + '">+</button><span>' + esc(step.label) + '</span></div>';
  }

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* On the cart page the gifts sit directly below the list of items. */
  function cartList() { return document.querySelector('.form-cart ul.l4ca'); }
  function ensureMount() {
    if (!onCartPage()) return;
    var list = cartList();
    if (!list || document.querySelector('.form-cart [data-nb-gifts]')) return;
    var m = document.createElement('div');
    m.className = 'nb-gifts';
    m.setAttribute('data-nb-gifts', '');
    m.setAttribute('data-mode', 'full');
    m.hidden = true;
    list.parentNode.insertBefore(m, list.nextSibling);
  }

  function render(cart) {
    ensureMount();
    var ids = giftIds();
    var total = spend(cart, ids);
    var unlocked = total >= cfg.threshold;
    var remaining = Math.max(cfg.threshold - total, 0);
    var pct = Math.min(100, Math.round((total / cfg.threshold) * 100));
    var inCart = {};
    cart.items.forEach(function (i) { if (isGift(i, ids)) inCart[i.variant_id] = true; });
    var inSet = setItems().every(function (it) { return inCart[it.id]; });
    var hasNb = cart.items.some(function (i) { return !isGift(i, ids) && (i.vendor || '').toLowerCase() === cfg.vendor.toLowerCase(); });

    document.querySelectorAll('[data-nb-gifts]').forEach(function (mount) {
      var compact = mount.getAttribute('data-mode') === 'compact';
      mount.setAttribute('data-nb-ready', '1');
      if (!hasNb) { mount.hidden = true; mount.innerHTML = ''; return; }
      mount.hidden = false;
      mount.className = 'nb-gifts' + (unlocked ? '' : ' is-locked');
      var html = '<h3>' + (unlocked ? 'Exclusive gifts unlocked' : 'Exclusive gifts') + '</h3>';
      if (!unlocked) {
        html += '<p class="nb-sub">Add ' + money(remaining) + ' more in Natura Bissé to unlock a complimentary Ellie Belle Beauty Bag and three travel sizes.</p>';
        html += '<div class="nb-bar"><span style="width:' + pct + '%"></span></div>';
      } else {
        html += '<p class="nb-sub">' + (inSet ? 'A complimentary Ellie Belle Beauty Bag and three travel sizes are in your bag.' : 'Choose your travel sizes to add your complimentary Ellie Belle Beauty Bag and travel sizes.') + '</p>';
      }
      if (compact) {
        if (unlocked) html += '<a class="nb-cta" href="' + cfg.cartUrl + '">Choose your travel sizes in your bag</a>';
        mount.innerHTML = html;
        return;
      }
      html += '<div class="nb-slots">';
      if (cfg.bag) {
        html += '<div class="nb-slot">' + (cfg.bag.image ? '<img src="' + cfg.bag.image + '" alt="">' : '') +
          '<span>' + esc(cfg.bag.title) + '</span><span class="nb-tag">' + (inCart[cfg.bag.id] ? 'Added' : (cfg.bag.available ? 'Complimentary' : 'Unavailable')) + '</span></div>';
      }
      html += '</div><p class="nb-choose">Choose your travel sizes</p><div class="nb-slots">';
      cfg.steps.forEach(function (s, i) { html += slotHtml(s, i, !!inCart[s.id], !unlocked); });
      html += '</div>';
      mount.innerHTML = html;
    });
  }

  /* ---------- step picker ---------- */
  function buildModal() {
    if (modal) return;
    modal = document.createElement('div');
    modal.className = 'nb-modal';
    modal.hidden = true;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    document.body.appendChild(modal);
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.closest('[data-nb-close]')) { modal.hidden = true; return; }
      var sel = e.target.closest('[data-nb-select]');
      if (sel) {
        selection[stepIndex] = cfg.steps[stepIndex].id;
        if (stepIndex < cfg.steps.length - 1) stepIndex++;
        drawModal();
        return;
      }
      if (e.target.closest('[data-nb-back]')) { stepIndex = Math.max(0, stepIndex - 1); drawModal(); return; }
      if (e.target.closest('[data-nb-next]')) { stepIndex = Math.min(cfg.steps.length - 1, stepIndex + 1); drawModal(); return; }
      if (e.target.closest('[data-nb-add]')) { addSelected(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal && !modal.hidden) modal.hidden = true; });
  }

  function drawModal() {
    var s = cfg.steps[stepIndex];
    var chosen = selection[stepIndex] === s.id;
    var allChosen = cfg.steps.every(function (st, i) { return selection[i] === st.id; });
    var last = stepIndex === cfg.steps.length - 1;
    modal.innerHTML = '<div class="nb-box"><button type="button" class="nb-close" data-nb-close aria-label="Close">&times;</button>' +
      '<h4>Choose your travel sizes</h4>' +
      '<p class="nb-step">Step ' + (stepIndex + 1) + ' of ' + cfg.steps.length + ': ' + esc(s.label) + '</p>' +
      '<div class="nb-card' + (chosen ? ' is-selected' : '') + '">' + (s.image ? '<img src="' + s.image + '" alt="">' : '') +
      '<div>' + esc(s.title) + '</div><div>Net wt. ' + esc(s.size) + '</div></div>' +
      '<div class="nb-actions">' +
      (stepIndex > 0 ? '<button type="button" data-nb-back>Back</button>' : '') +
      (chosen ? '' : '<button type="button" class="nb-primary" data-nb-select>Select</button>') +
      (chosen && !last ? '<button type="button" class="nb-primary" data-nb-next>Next</button>' : '') +
      (last ? '<button type="button" class="nb-primary" data-nb-add' + (allChosen ? '' : ' disabled') + '>Add to your bag</button>' : '') +
      '</div></div>';
  }

  function openModal(idx, cart) {
    buildModal();
    var ids = {};
    cart.items.forEach(function (i) { ids[i.variant_id] = true; });
    selection = {};
    cfg.steps.forEach(function (s, i) { if (ids[s.id]) selection[i] = s.id; });
    stepIndex = idx;
    drawModal();
    modal.hidden = false;
  }

  function addSelected() {
    var allChosen = cfg.steps.every(function (st, i) { return selection[i] === st.id; });
    if (!allChosen || !setAvailable()) return;
    getCart().then(function (cart) {
      var ids = giftIds();
      var u = {};
      cart.items.forEach(function (i) { if (isGift(i, ids)) u[i.key] = 0; });
      var clear = Object.keys(u).length ? post('/cart/update.js', { updates: u }) : Promise.resolve();
      return clear.then(function () { return post('/cart/add.js', { items: setItems() }); }).then(function () {
        ss(false, KEY_DISMISSED, null);
        ss(false, KEY_SEEN, '1');
        modal.hidden = true;
        if (onCartPage()) location.reload(); else run();
      });
    });
  }

  /* ---------- wiring ---------- */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-nb-open]');
    if (open) {
      e.preventDefault();
      var idx = parseInt(open.getAttribute('data-nb-open'), 10);
      getCart().then(function (cart) { openModal(idx, cart); });
      return;
    }
    var rem = e.target.closest('[data-nb-remove]');
    if (rem) {
      e.preventDefault();
      getCart().then(function (cart) {
        var ids = giftIds();
        var u = {};
        cart.items.forEach(function (i) { if (isGift(i, ids)) u[i.key] = 0; });
        return post('/cart/update.js', { updates: u }).then(function () {
          ss(false, KEY_DISMISSED, '1');
          if (onCartPage()) location.reload(); else run();
        });
      });
    }
  });

  /* Never let a customer pay for a gift: reconcile before checkout. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelector || !form.querySelector('[name="checkout"]')) return;
    if (form.__nbChecked) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    run({ noReload: true }).then(function () {
      form.__nbChecked = true;
      HTMLFormElement.prototype.submit.call(form);
    });
  }, true);

  /* React to cart changes made by the theme. */
  var origFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (!busy && /\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { schedule(); }, function () {});
    }
    return p;
  };
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (!busy && /\/cart\/(add|change|update|clear)/.test(String(url))) {
      this.addEventListener('loadend', function () { schedule(); });
    }
    return origOpen.apply(this, arguments);
  };

  /* The cart list can be re-rendered by the theme, so put the gifts back when needed. */
  var mo = new MutationObserver(function () {
    if (onCartPage() && cartList() && !document.querySelector('.form-cart [data-nb-gifts]')) { schedule(); }
  });

  function init() {
    cfg = readCfg();
    if (!cfg) return;
    mo.observe(document.body, { childList: true, subtree: true });
    run();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
